/**
 * Реквизиты исполнителя (получателя платежей) для отображения в приложении.
 * Используется в подвале меню, на странице логина и в дополнении к оферте.
 */
export const LEGAL = {
  /** URL договора оферты на сайте */
  offerUrl: 'https://ligatrenerov.ru/agreement',

  /**
   * Ключ Capacitor Preferences для согласия с Политикой.
   * При существенном обновлении Политики меняйте версию в имени ключа,
   * чтобы запросить согласие повторно.
   */
  privacyConsentKey: 'privacy_consent_v2_accepted',

  /** Краткое наименование для подписи «Платежи принимает: ...» */
  payeeShortName: 'ИП Хусаинова Н. Х.',

  /** Полные реквизиты исполнителя */
  payee: {
    fullName: 'ИП Хусаинова Найля Харисовна',
    inn: '301711635262',
    ogrnip: '319774600596631',
    address: '121609, г. Москва, ул. Крылатские Холмы, д. 1',
    phone: '+7 (909) 661-18-13',
    email: 'Nelli3000@mail.ru',
  },
} as const;
